(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var page = document.querySelector('[data-cart-page]');
    if (!page) return;

    var moneyFormat = page.dataset.moneyFormat || '';
    var amountPattern = new RegExp('\\{\\{\\s*amount[^}]*\\}\\}');

    function formatMoney(cents) {
      var value = (cents / 100).toFixed(2);
      if (!moneyFormat) return value;
      return moneyFormat.replace(amountPattern, value);
    }

    page.addEventListener('click', function (event) {
      var item = event.target.closest('[data-cart-item]');
      if (!item) return;

      var qtyBtn = event.target.closest('[data-cart-qty]');
      if (!qtyBtn) return;

      event.preventDefault();
      var display = item.querySelector('[data-cart-qty-display]');
      var current = parseInt(display.textContent, 10) || 0;
      var next = qtyBtn.dataset.cartQty === 'inc' ? current + 1 : Math.max(0, current - 1);

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: item.dataset.key, quantity: next }),
      })
        .then(function (r) { return r.json(); })
        .then(function (state) {
          if (next === 0) {
            window.location.reload();
            return;
          }
          var line = (state.items || []).filter(function (li) {
            return String(li.key) === String(item.dataset.key);
          })[0];
          if (line) {
            display.textContent = line.quantity;
            var price = item.querySelector('[data-cart-item-price]');
            if (price) price.textContent = formatMoney(line.final_line_price);
          }
          var total = page.querySelector('[data-cart-total]');
          if (total) total.textContent = formatMoney(state.total_price);
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('[data-variant-select]').forEach(function (select) {
    var scope = select.closest('[data-product-buybox]');
    if (!scope) return;

    var priceTarget = scope.querySelector('[data-price]');
    if (!priceTarget) return;

    select.addEventListener('change', function () {
      var option = select.options[select.selectedIndex];
      if (option && option.dataset.price) {
        priceTarget.textContent = option.dataset.price;
      }
    });
  });

  document.querySelectorAll('[data-more-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const wrapper = btn.closest('.product__details-body');
      const more = wrapper.querySelector('[data-more-content]');
      const expanded = btn.getAttribute('aria-expanded') === 'true';

      more.hidden = expanded;
      btn.setAttribute('aria-expanded', String(!expanded));
    });
  });

  } catch(e) { console.error(e); }
})();
})();
